export default __webpack_public_path__ + "3824cedae4fb6fd1988660d604db45a0.svg";